module.exports = __webpack_public_path__ + "img/quotes-draft.525d9040.svg";